export type SocketNoticeType = 'transaction' | 'token_transfer' | 'deposit' | 'block';

const SOCKET_NOTICE_KEYS = {
  transaction: {
    scanning: 'common.socketNotice.scanningTransactions',
    one: 'common.socketNotice.transactionsOne',
    other: 'common.socketNotice.transactionsOther',
  },
  token_transfer: {
    scanning: 'common.socketNotice.scanningTokenTransfers',
    one: 'common.socketNotice.tokenTransfersOne',
    other: 'common.socketNotice.tokenTransfersOther',
  },
  deposit: {
    scanning: 'common.socketNotice.scanningDeposits',
    one: 'common.socketNotice.depositsOne',
    other: 'common.socketNotice.depositsOther',
  },
  block: {
    scanning: 'common.socketNotice.scanningBlocks',
    one: 'common.socketNotice.blocksOne',
    other: 'common.socketNotice.blocksOther',
  },
} as const satisfies Record<SocketNoticeType, Record<'scanning' | 'one' | 'other', string>>;

export function getSocketNoticeKey(type: SocketNoticeType, count?: number) {
  if (!count) {
    return SOCKET_NOTICE_KEYS[type].scanning;
  }

  return count === 1 ? SOCKET_NOTICE_KEYS[type].one : SOCKET_NOTICE_KEYS[type].other;
}
